// ────────────────────────────────────────────────────────────────
// core/guards/capability.guard.ts — capability-based route gating (§5.3)
// Usage on a route: `canActivate: [authGuard, capabilityGuard], data:
// { capabilities: ['config.read'] }`. Access is granted when the admin
// holds ANY of the listed capabilities (routes list the minimum set that
// makes the screen useful). Missing capability → redirect home.
// ────────────────────────────────────────────────────────────────

import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { SessionStore } from '../auth/session.store';
import { Capability } from '../models/admin.model';

export const capabilityGuard: CanActivateFn = (route) => {
  const session = inject(SessionStore);
  const router = inject(Router);

  const required = (route.data?.['capabilities'] as Capability[] | undefined) ?? [];
  if (session.hasAnyCapability(required)) return true;

  return router.createUrlTree(['/']);
};
